import apiClient from './apiClient';

export class SystemStatsService {
  async getDashboard(search) {
    const response = await apiClient.getWithCache("api/systemStats/dashboard", {
      params: search,
      cacheDuration: 1000 * 60 * 30
    });
    return response.data;
  }

  /**
   * 
   * @returns {Promise<{
   *   MarketplaceName: string,
   *           ApiName: string,
   *              Date: string,
   *             Count: number
   * }>}
   */
  async getAPICalls() {
    const response = await apiClient.getWithCache("api/systemStats/apiCalls", { cacheDuration: 1000 * 60 * 30 });

    return response.data;
  }
}  